import React, { useState } from "react";

import { CloseIcon } from "../Icons";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";
import {
  useCombinedAlertsDataStore,
} from "../../hooks/redux-hooks/combined-alerts-data-store/combined-alerts-data-store";
import { useDismissWPUpsellCard } from "../../hooks/useDismissWPUpsell";
import { useWellnessFunnel } from "../../hooks/useWellnessFunnel";
import { userActivityLogger } from "../../utils/mixpanel";

export const EnrollPlanCard = () => {
  const [isVisible, setIsVisible] = useState<boolean>(true);
  const { shouldShowWellnessUpSell } = useCombinedAlertsDataStore();
  const dismissWPUpsellCard = useDismissWPUpsellCard();
  const funnel = useWellnessFunnel({ source: "plan_and_billing" });

  const handleCloseModal = () => {
    userActivityLogger(MIXPANEL_EVENTS.USER_CLOSES_DASHBOARD_UPSELL_CARD, {});
    userActivityLogger(MIXPANEL_EVENTS.WP_UPSELL_DISMISSED, {
      surface: "plan_and_billing",
      referred_from: "plan_and_billing",
    });
    setIsVisible(false);
    dismissWPUpsellCard();
  };

  if (!isVisible || !funnel.canEnter || !shouldShowWellnessUpSell) {
    return null;
  }

  return (
    <div
      className="relative bg-white rounded-xl shadow-[2px_2px_18px_0px_rgba(55,54,23,0.10)]
        p-4 flex flex-col gap-3 mb-1">
      <div className="absolute top-2 right-2 hover:bg-taupe-1 hover:rounded-full">
        <CloseIcon
          onClick={handleCloseModal}
          className="text-light-black cursor-pointer"
        />
      </div>

      <div className="flex gap-3">
        <img
          alt="wellness_icon"
          src="/assets/icons/WellnessPlan.svg"
          className="w-24 h-24"
        />
        <div className="flex flex-col justify-center">
          <div className="text-base font-semibold my-1">Join the TotalCare Plan</div>
          <div className="text-xs">
          Comprehensive, vet-designed plans to keep your pet&apos;s care on track.
          </div>
        </div>
      </div>

      <div
        className="text-sm text-center w-full bg-violet-3
          p-1.5 rounded-2xl font-semibold hover:bg-gray-3 cursor-pointer"
        onClick={funnel.start}>
        Explore Plans
      </div>
    </div>
  );
};

export default EnrollPlanCard;
